import { getAuthToken } from "./utils";

const BASE_URL = "https://student-json-api.lidemy.me";

// api https://github.com/Lidemy/lidemy-student-json-api-server
// https://student-json-api.lidemy.me/posts?userId=1&_expand=user
// https://student-json-api.lidemy.me/posts?id=1
export const getPosts = () => {
	return fetch(`${BASE_URL}/posts?_sort=createdAt&_order=desc`)
		.then( (res) => res.json());
};

export const getPostId = (id) => {
	return fetch(`${BASE_URL}/posts?id=${id}`)
		.then( (res) => res.json());
};

// https://student-json-api.lidemy.me/login
// user01 Lidemy
export const login = (username, password) => {
	return fetch(`${BASE_URL}/login`, {
		method: 'POST',
		headers: {
			'content-type': 'application/json'
		},
		body: JSON.stringify({
			username,
			password
		})
	})
	.then(res => res.json());
};

export const getMe = () => {
	const token = getAuthToken();

	return fetch(`${BASE_URL}/me`, {
		headers: {
			'authorization': `Bearer ${token}`
		}
	})
	.then(res => res.json());
};

// https://student-json-api.lidemy.me/posts
export const create = (title , body ) => {
	const token = getAuthToken();

	return fetch(`${BASE_URL}/posts`, {
		method: 'POST',
		headers: {
			'content-type': 'application/json',
			'authorization': `Bearer ${token}`,
		},
		body: JSON.stringify({
			title,
			body
		})
	})
	.then(res => res.json());
};
